import { tr } from '../utils/e7n-util';

const data = {
  benefits: [
    {
      title: tr('Fast & Simple'),
      text: tr('one click to capture a full webpage'),
    },
    {
      title: tr('Privacy'),
      text: tr('no extra permissions are required to install'),
    },
    {
      title: tr('Accuracy'),
      text: tr('the most advanced capturing of difficult pages'),
    },
    {
      title: tr('Trusted'),
      text: tr('the highest rated screenshot tool with {STATS.users} users'),
    },
    {
      title: tr('More'),
      text: tr('download as PNG, JPG, PDF, etc…'),
    },
    {
      title: tr('Edit'),
      text: tr('Add shapes, emojis, annotations, and more!'),
      linkText: tr('Go Premium!'),
      type: tr('premium'),
    },
  ],
  reviews: [
    // NOTE: auto-download avatars using `tools/format-review-image.sh '<url>' '<name>'
    {
      name: 'Alexandre A.',
      date: 'Mar 24, 2026',
      text: "I don't install Chrome extensions that often because of privacy reasons. But this extension is safe as f*dge.\nThanks to you guys for maintaining it !",
      img: '/static/reviews/aa.jpg', // https://lh3.googleusercontent.com/a-/ALV-UjVhR3aUjKH1JdWSTpCcXkz2hIHbc1LqF6GMUqeYnnWKH2O3qkrJ
      img2x: '/static/reviews/aa@2x.jpg',
    },
    {
      name: 'Mahjabeen',
      date: 'Dec 20, 2025',
      text: "It's the ONLY extension I use for capturing full webpages! I've come a long way using multiple extensions with limited quota and getting sick because I'd need to install another one the next day. There's no limit to how many screenshots you take with GoFullPage, and it's totally free!!!",
      img: '/static/reviews/m.jpg', // https://lh3.googleusercontent.com/a-/ALV-UjUx_LGMMNbhFZEYvTfzJnVZS4Tb-lZSdouZx2iV1PehSP_k_z8
      img2x: '/static/reviews/m@2x.jpg',
    },
    {
      name: 'Eric Y.',
      date: 'Sep 12, 2024',
      text: 'I am so happy I found GoFullPage. I am an attorney, and I frequently need to screenshot webpages to use with court filings. I was using a different Chrome app, which worked well at first, but then I paid for a lifetime license which only worked for a few months before I got dinged to buy a license again. I decided to switch. There are not that many apps out there that can do this quickly, cleanly, and provide just enough features to make the app usable and not boggy. GoFullPage does exactly what I need, it does it quickly, and after several weeks, I have had no problems with it. I highly recommend this app.',
      img: '/static/reviews/ey.jpg', // https://lh3.googleusercontent.com/a-/ALV-UjXtTi8Cbt3cNYRNAdjo5TRHRH8w48v0nQLLwPp_n7xi2i04M88S
      img2x: '/static/reviews/ey@2x.jpg',
    },
    {
      name: 'Shahbaz A.',
      date: 'Jun 27, 2023',
      text: "On the occasions when I feel it's necessary to capture a full page, it does what it says on the tin.\nRecently I came across a  page that I believed would be a challenge even for GoFullPage. It wasn't, they simply divided the page into 5 sections meaning 5 pages, it was incredible and no loss of quality. You guessed it, it was a big page full of resourceful content and nothing was lost. I was impressed. GoFullPage gets 5-Stars from me All Day, Every Day. Thank you.",
      img: '/static/reviews/sha.jpg', // https://lh3.googleusercontent.com/a-/AD_cMMRzZTGuamn3SpVU0t-hEw4iOF7Icjwzp5VXbMzhWBiyZqHC
      img2x: '/static/reviews/sha@2x.jpg',
    },

    {
      name: 'Neal B.',
      date: 'May 11, 2022',
      text: "We’ve used several third-party, stand alone screen cap applications but GoFullPage is the simplest to use, integrates easily into our workflow, and delivers exceptional results every time. We take screen cap pictures of EVERYTHING now and it's all thanks to this single extension.",
      img: '/static/reviews/nb.jpg',
      img2x: '/static/reviews/nb@2x.jpg',
    },
    {
      name: 'Sean G.',
      date: 'May 28, 2021',
      text: 'Fantastic app and works better than most paid software to do the same task. Probably even more surprisingly is that once when i had an issue with a reaaaaaaallyyy long page i submitted a bug report to them and they got back to me within 24 hours with a solution!',
      img: '/static/reviews/sg.jpg',
      img2x: '/static/reviews/sg@2x.jpg',
    },
    {
      name: 'Gabi W.',
      date: 'Nov 29, 2020',
      text: "This is just the extension I need. The normal extension i used doesn't work as expected on my Mac versus on my WIN. But this extension works on both ! Appreciate the effort yall took to make a great extension and the cost is unbeatable!",
      img: '/static/reviews/gw.jpg', // https://gwaldenalves.com/cv4az2fl1/wp-content/uploads/elementor/thumbs/IMG_6048-oalzm0pd7v867kthrzeo530qql5tcdusv59c4hy8mk.jpg
      img2x: '/static/reviews/gw@2x.jpg',
    },
    {
      name: 'Nikola V.',
      date: 'Jan 28, 2019',
      text: 'Full Page Screen Capture extension is amazing! I am Chicago based award winning designer. I am doing market every day. Going deep is what make me create great value and results for my clients. Great part of that research is scanning the web pages. Before the "Full Page Screen Capture" it was a nightmare to scan hundreds of pages. Now it\'s no brainer, fast and useful. Highly recommended!',
      img: '/static/reviews/nv.jpg', // https://competition.adesignaward.com/award-winner-designer.php?profile=149457
      img2x: '/static/reviews/nv@2x.jpg',
    },

    // ## OLD REVIEWS
    // {
    //   name: 'Akash D.',
    //   date: 'Nov 16, 2023',
    //   text: "Loved it and loving it. As a UX designer, taking screenshots of long pages is really helpful. But, here's the ,kicker - it even scrolls the correct parts of certain websites like GMail where I'd only like it to scroll the open email instead of scrolling everything. I don't know how y'all do this or if it's luck but it's amazing. It literally made me write this review, thank you.",
    //   img: '/static/reviews/ad.jpg',
    //   img2x: '/static/reviews/ad@2x.jpg',
    // },
    // {
    //   name: 'Rebecca R.',
    //   date: 'Nov 12, 2023',
    //   text: 'A Straight Forward App That Works Great! This app does what it says and says what it does with no extra distractions. LOVE IT! Easy to set up and to use. Saves me so much time from prior cutting and pasting of information into another document just so I could have all the information on a page below the fold. Thank you to the developer - from those of us who like simple.',
    //   img: '/static/reviews/rr.jpg',
    //   img2x: '/static/reviews/rr@2x.jpg',
    // },
    // {
    //   name: 'Melissa W.',
    //   date: 'Dec 2, 2021',
    //   text: "I am a Sales Engineer for a software company and this tool is so useful when seeking to quickly create a full length snapshot of the custom views we've built in our software so we can share them with customers in emails. It helps us communicate the full page value of our software quickly and easily. Easy to download and use so can promote it across the team. Great stuff.",
    //   img: '/static/reviews/mw.jpg',
    //   img2x: '/static/reviews/mw@2x.jpg',
    // },
    // {
    //   name: 'John A.',
    //   date: 'July 9, 2021',
    //.  text: "Many times, I find that Chrome extensions aren’t very well designed and do either more or less than what is described or what I need it to do. GoFullPage is by far, the best extension I have and is the one I use most often. It does exactly what it’s desigend to do and does it right every time. I can’t believe I’m giving a review of an extension, but for me, GFP is worth the time to recommend this very useful tool.",
    //   img: '/static/reviews/ja.jpg',
    //   img2x: '/static/reviews/ja@2x.jpg',
    // },
    // {
    //   name: 'Leisl B.',
    //   date: 'April 22, 2021',
    //   text: "I use this all the time to take pictures of websites and sales pages. I use the pro version to audit clients' sales pages and LOVE it. It's super professional, easy to use, and I recommend it to anyone who needs to take pictures of full websites or images.",
    //   img: '/static/reviews/lb.jpg',
    //   img2x: '/static/reviews/lb@2x.jpg',
    // },
    // {
    //   name: 'Areeta M.',
    //   date: 'Apr 12, 2021',
    //   text: "A life saver and game changer! Been using this for about a year and I've never had any problems. I use it almost every day as a web designer and it's never let me down. Don't know where I would be without it! Thank you!",
    //   img: '/static/reviews/am.jpg',
    //   img2x: '/static/reviews/am@2x.jpg',
    // },
    // {
    //   name: 'Soheil A.',
    //   date: 'Mar 24, 2021',
    //   text: 'Tried many many extension. This one is the best. Easy to copy to clipboard and then paste into Miro, Framer, Figma. It also automatically reduces the size so it fit in Google drive. Well done 🎉',
    //   img: '/static/reviews/soa.jpg',
    //   img2x: '/static/reviews/soa@2x.jpg',
    // },
    // {
    //   name: 'Gabriel R.',
    //   date: 'Dec 7, 2020',
    //   text: "I've been using this extension for a couple of years now, and I love it. At work, I do a lot of competitor research. Being able to capture a full screen in a single click saves me a ton of time and hassle. I can line up the page that I want, click, change tab, click, change tab... Then download. It's great!",
    //   img: '/static/reviews/gr.jpg',
    //   img2x: '/static/reviews/gr@2x.jpg',
    // },
  ],
};

export default data;
